import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function ActionSection() {
  return <section className="relative py-32 bg-[#2E78B6] overflow-hidden" data-id="element-1">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-2">
        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80" alt="Industrial background" className="w-full h-full object-cover" data-id="element-3" />
        <div className="absolute inset-0 bg-[#2E78B6]/90 mix-blend-multiply" data-id="element-4"></div>
        <div className="absolute inset-0 bg-black/30" data-id="element-5"></div>
      </div>

      {/* Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 pointer-events-none z-10" style={{
      backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-6" />

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-8">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 drop-shadow-md" data-id="element-9">
            Op zoek naar een betrouwbare onderaannemer?
          </h2>
          <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto font-light" data-id="element-10">
            Wij staan klaar om uw project veilig, efficiënt en professioneel uit
            te voeren.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-12" data-id="element-11">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md px-6 py-4 rounded-lg border border-white/20 hover:bg-white/20 transition-colors" data-id="element-12">
              <Phone className="w-6 h-6 text-[#F57C00]" data-id="element-13" />
              <span className="text-white font-semibold text-lg" data-id="element-14">
                +31 (0) 72 5626656
              </span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md px-6 py-4 rounded-lg border border-white/20 hover:bg-white/20 transition-colors" data-id="element-15">
              <Mail className="w-6 h-6 text-[#F57C00]" data-id="element-16" />
              <span className="text-white font-semibold text-lg" data-id="element-17">
                alkmaar@plubos.nl
              </span>
            </div>
          </div>

          <Button className="bg-[#F57C00] hover:bg-[#E56A00] text-white text-xl px-10 py-5 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all border-2 border-transparent" data-id="element-18">
            Neem contact op
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-19" />
          </Button>
        </motion.div>
      </div>
    </section>;
}